import { Form, connect } from 'formik'
import { Debug } from '../debug'
import {
  AddressFields,
  AmountField,
  CompanyFields,
  FakeButtons,
  GeneralError,
  GiftInfo,
  HeroImage,
  HolderFields,
  HolderHeadline,
  MatchingFundBanner,
  MessageField,
  MonthlyMatchingFundBanner,
  PaymentMethodSelection,
  PaymentMethodError,
  PlatformNewsletterCheckbox,
  RecurringSelection,
  StripeCCFields,
  StripeSEPADebitFields,
  SubmitButton,
  Summary,
  Terms,
  TrustLogos,
} from '../shared'
import { ProhibitedNotice } from './prohibited_notice'
import { DSIHtml } from 'shared'

export const PlatformForm = connect(({ display, config, formik }) => {

  const addressRequired = formik.values._company_donation || formik.values.payment_method == 'paydirekt'

  if (config.donationsProhibited) {
    return <WrappingDivs>
      <HeroImage {...display} linked />
      <ProhibitedNotice href={display.receiverUrl} />
    </WrappingDivs>
  }

  return <>
    <WrappingDivs>
      <HeroImage {...display} linked />
      <Form>
        <div className='donate-form-content generic-popover-constraints'>
          <GeneralError />

          <div className="donations-form-amount-selection">
            <h4 className="amount-headline">
              {I18n.t("donate.attributes.amount")}
            </h4>
            <div className="amount-wrapper mb-3">
              <div className='amount-input-wrapper'>
                <AmountField className='form-control' currencySymbol='€' autoFocus config={config} />
              </div>
              <div className="donations-form-recurring-selection">
                <RecurringSelection />
              </div>
            </div>
          </div>

          <MonthlyMatchingFundBanner config={config} display={display} />

          <MatchingFundBanner config={config} display={display} />

          <div className="form-fields">
            <PaymentMethodSelection />
            <HolderHeadline />
            {config.editProfileUrl &&
              <p className='hint' dangerouslySetInnerHTML={{ __html: I18n.t('donate.prefill_from_account_hint_html', { edit_profile_url: config.editProfileUrl }) }} />
            }
            <HolderFields />
            <CompanyFields />
            {addressRequired && <AddressFields required />}
            <MessageField config={config} />
            {!addressRequired && <AddressFieldToggle />}
            <StripeCCFields publicKey={display.stripePublicKey} />
            <StripeSEPADebitFields publicKey={display.stripePublicKey} />
            <PaymentMethodError />
            <Summary config={config} display={display} />
            <PlatformNewsletterCheckbox />
            <SubmitButton />
            {config.receiverType === 'Project' && <GiftInfo enabled={false} />}
            <Terms />
            <TrustLogos />
          </div>
          <FakeButtons />
          <Debug />
        </div>
      </Form>
    </WrappingDivs>
  </>
})

const WrappingDivs = ({ children }) =>
  <div className='donate-form platform-donations-new'>
    <div className="bg-teal-500">
      <div className="container preserves-space-for-transparent-header">
        <div className="row">
          <div className="col-md-16 offset-md-4 wrapper">
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>

export const AddressFieldToggle = connect(({ formik }) => {

  const receiptDesired = formik.values.receipt_desired

  return <div className='my-12'>
    <label className='generic-custom-radio-field w-full mb-3' htmlFor='receiveReceipt'>
      <input
        type='checkbox'
        id='receiveReceipt'
        onChange={() => {
          formik.setFieldValue('receipt_desired', !receiptDesired)
          if (receiptDesired) { // if previously true, i.e. when hiding address fields
            formik.setFieldValue('street', '')
            formik.setFieldValue('zip', '')
            formik.setFieldValue('city', '')
          }
        }}
        checked={receiptDesired}
      />
      <span className='generic-custom-radio' />
      <DSIHtml value={I18n.t("donate.receipt_desired_html")} />
    </label>
    {receiptDesired && <AddressFields required />}
  </div>
})
